/**
 * Leo SOC助手 · 浮球／浮窗布局（localStorage）
 */
const LS_KEY = 'leo_soc_assistant_layout_v1'

function readRaw () {
  if (typeof localStorage === 'undefined') return null
  try {
    const o = JSON.parse(localStorage.getItem(LS_KEY) || 'null')
    return o && typeof o === 'object' ? o : null
  } catch (e) {
    return null
  }
}

function writeRaw (next) {
  if (typeof localStorage === 'undefined') return
  try {
    localStorage.setItem(LS_KEY, JSON.stringify(next || {}))
  } catch (e) {}
}

/**
 * 讀取浮球座標；若已拖出視窗外則回 null（呼叫端回落到預設右下角）。
 * @param {{ width?: number, height?: number, pad?: number, fabW?: number, fabH?: number }} [viewport]
 * @returns {{ left: number, top: number }|null}
 */
export function getAssistantFabPos (viewport) {
  const o = readRaw()
  if (!o || !o.fab) return null
  const left = Number(o.fab.left)
  const top = Number(o.fab.top)
  if (Number.isNaN(left) || Number.isNaN(top)) return null
  const vw = Number(viewport && viewport.width)
  const vh = Number(viewport && viewport.height)
  if (vw > 0 && vh > 0) {
    const pad = Number(viewport.pad) >= 0 ? Number(viewport.pad) : 8
    const fabW = Number(viewport.fabW) > 0 ? Number(viewport.fabW) : 56
    const fabH = Number(viewport.fabH) > 0 ? Number(viewport.fabH) : 56
    if (left < pad - fabW || top < pad - fabH || left > vw - pad || top > vh - pad) {
      return null
    }
  }
  return { left, top }
}

export function setAssistantFabPos (left, top) {
  const o = readRaw() || {}
  o.fab = { left, top }
  writeRaw(o)
}

/** @returns {{ left: number, top: number, width: number, height: number }|null} */
export function getAssistantPanelLayout () {
  const o = readRaw()
  if (!o || !o.panel) return null
  const left = Number(o.panel.left)
  const top = Number(o.panel.top)
  const width = Number(o.panel.width)
  const height = Number(o.panel.height)
  if ([left, top, width, height].some((n) => Number.isNaN(n))) return null
  if (width < 1 || height < 1) return null
  return { left, top, width, height }
}

export function setAssistantPanelLayout (layout) {
  const o = readRaw() || {}
  const cur = o.panel || {}
  o.panel = Object.assign({}, cur, layout || {})
  writeRaw(o)
}



// WEBPACK FOOTER //
// ./src/utils/leoOperatorAssistantLayout.js